import InputMask, { ReactInputMask } from 'react-input-mask';

function CardNumberMask(props: Readonly<ReactInputMask>) {
  return <InputMask mask={'9999 9999 9999 9999'} {...props} />;
}

export default CardNumberMask;
